import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import BeelineRoutesIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/BeelineRoutesAppIcon';

import BeelineRoutesButton from '../OtherComponents/BeelineRoutesButton';

const BeelineRoutesStrategy = {
  headerInfo: {
    name: 'Beeline Routes',
    category: 'Route Optimization',
    details: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography paragraph>
            Driving is lost time on the road and lost man-hours for your business. Current solutions range from pen and
            paper maps to moving dots around on a map, while keeping in your head everything from information about the
            job (such as special equipment and expertise), the customer, and your business (such as vehicles out for
            maintenance) on a daily basis. This is where Beeline Routes comes in.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <h4>Why Beeline Routes?</h4>
          <ul>
            <li>
              Beeline Routes offers two different products to help optimize your schedule for existing and new
              appointments, making sure you get to the customer in time while finding shorter routes whenever possible:
            </li>
            <li>The Daily product lets YOU choose when and how to optimize your schedule.</li>
            <li>
              The BestFit product supports better scheduling upfront, by recommending appointment times that work within
              your existing routes.
            </li>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <h4>What you get with Beeline Routes:</h4>
          <ul>
            <li>
              When Beeline Daily plans a route, we account for jobs that are confirmed in advance and optimize for those
              jobs so you don’t have to change existing customer appointments.
            </li>
            <li>
              When Beeline BestFit suggests new jobs to add to a route, we plan for the jobs that are scheduled and then
              fit additional jobs in the queue when it makes sense for the route.
            </li>
            <li>Beeline customers receive dedicated, live support from human beings when you need it.</li>
          </ul>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 'bold' }}>Interested to learn more?</Typography>
          <p>
            <a href="https://beelineroutes.com/housecall-app-store/"> Get Started with a 7 day free trial. </a>
          </p>
        </Grid>
      </Grid>
    ),
    iconSvg: <BeelineRoutesIcon size="xlarge" />,
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Partner Pricing',
    hideToggle: true,
    appActionButton: <BeelineRoutesButton />,
    description: (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Typography align="right">+ $125 for 1-5 trucks</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography align="right">+ $250 for 5-10 trucks</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    ),
  },
  sellingPoints: {},
  supportContacts: [
    {
      type: 'Email',
      contact: (
        <div>
          <a href="mailto:hcpsupport@beelineroutes.com">hcpsupport@beelineroutes.com</a>
        </div>
      ),
    },
  ],
};

export default BeelineRoutesStrategy;
